import topBars from '@/constants/topBars';

export const actions = {
  updateMobileTopBarContent({ commit }, obj) {
    commit('setMobileTopBarContent', obj);
  },
  clearMobileTopBarContent({ commit }) {
    commit('setMobileTopBarContent', {});
  },
  setTopBarToRestoreTo({ commit }, restoreOrigin) {
    commit('setTopBarToRestoreTo', restoreOrigin);
  },
};

export const mutations = {
  setMobileTopBarContent(state, obj) {
    state.mobileTopBarContent = { ...obj };
  },

  setTopBarToRestoreTo(state, restoreOrigin) {
    state.topBarToRestoreTo = restoreOrigin;
  },
};

export const getters = {
  getMobileTopBarSchema: () => (origin) => topBars[origin],
  topBarToRestoreTo: (state) => state.topBarToRestoreTo,
  mobileTopBarContent: (state) => state.mobileTopBarContent,
  hasMobileTopBarContent: (state) => !!Object.keys(state.mobileTopBarContent).length,
  isMobileTopBarOrigin: (state) => (origin) => state.mobileTopBarContent.origin === origin,
  mobileMenuOpened: (state) => state.mobileTopBarContent.comingFrom
    || state.mobileTopBarContent.navigationMenu,
};

export const state = {
  mobileTopBarContent: {},
  topBarToRestoreTo: '',
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
